import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export default function ClientInfoSection({
  modeloMoto,
  setModeloMoto,
  precioTotal,
  setPrecioTotal,
  valorCuota,
  setValorCuota,
  calc,
  pagosSeguros
}) {
  return (
    <div className="bg-[#2A2A2A] border border-white/10 rounded-lg p-6" data-testid="financial-section">
      <h2 className="font-heading text-xl text-[white] font-semibold mb-4">Datos Financieros</h2>
      <div className="space-y-4">
        <div>
          <Label className="text-[white] text-sm font-body uppercase tracking-wider mb-2 block">
            Modelo de Moto
          </Label>
          <Input
            type="text"
            value={modeloMoto}
            onChange={(e) => setModeloMoto(e.target.value)}
            className="bg-[#2A2A2A] border border-white/20 text-[white]"
            placeholder="Ej: Honda CB 190"
            data-testid="modelo-moto-input"
          />
        </div>

        <div>
          <Label className="text-[white] text-sm font-body uppercase tracking-wider mb-2 block">
            Precio Total (REF)
          </Label>
          <Input
            type="number"
            value={precioTotal}
            onChange={(e) => setPrecioTotal(e.target.value)}
            className="bg-[#2A2A2A] border border-white/20 text-[white]"
            placeholder="0.00"
            data-testid="precio-total-input"
          />
        </div>

        <div>
          <Label className="text-[white] text-sm font-body uppercase tracking-wider mb-2 block">
            Valor Cuota Mensual (REF)
          </Label>
          <Input
            type="number"
            value={valorCuota}
            onChange={(e) => setValorCuota(e.target.value)}
            className="bg-[#2A2A2A] border border-white/20 text-[white]"
            placeholder="0.00"
            data-testid="valor-cuota-input"
          />
        </div>

        <div className="pt-4 border-t border-white/10 space-y-2">
          <div className="flex justify-between">
            <span className="text-[#666666] font-body">Total Aportado:</span>
            <span className="text-[#10B981] font-heading font-semibold" data-testid="aporte-display">
              REF {calc.aporte.toFixed(2)}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-[#666666] font-body">Restante:</span>
            <span className="text-[#F59E0B] font-heading font-semibold" data-testid="restante-display">
              REF {calc.restante.toFixed(2)}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-[#666666] font-body">Tiempo Restante:</span>
            <span className="text-[#F5A623] font-heading font-semibold" data-testid="tiempo-restante-display">
              {calc.tiempoRestante.toFixed(1)} meses
            </span>
          </div>
          <div className="flex justify-between pt-2 border-t border-white/10">
            <span className="text-[#666666] font-body">Pagos de Seguros:</span>
            <span className="text-[#3B82F6] font-heading font-semibold" data-testid="seguros-display">
              REF {pagosSeguros.toFixed(2)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
